import { 
  Radar, 
  Cloud, 
  Plane, 
  Link, 
  Anchor, 
  Fuel, 
  Armchair, 
  VolumeOff, 
  Shield, 
  AlertTriangle, 
  Filter, 
  Eye, 
  Lightbulb, 
  Gauge,
  Settings,
  Zap,
  MapPin,
  Crosshair,
  Droplets,
  Truck,
  Users,
  Wrench,
  Star,
  Mountain,
  Waves,
  Navigation,
  Compass,
  Cpu,
  Monitor,
  HardDrive,
  Phone,
  Radio,
  Wifi,
  Satellite,
  Headphones,
  Mic,
  Moon,
  CloudRain,
  Volume2,
  EyeOff,
  Wheat,
  Heart,
  Scale,
  GraduationCap,
  Target,
  Camera,
  BookOpen,
  HardHat,
  type LucideIcon
} from 'lucide-react';

// Enhanced aviation icon mapping for helicopter options
export const iconMapping = {
  // Legacy .svg mappings
  'radar.svg': Radar,
  'cloud.svg': Cloud,
  'auto.svg': Plane,
  'chain.svg': Link,
  'winch.svg': Anchor,
  'tank.svg': Fuel,
  'seat.svg': Armchair,
  'quiet.svg': VolumeOff,
  'shield.svg': Shield,
  'tcas.svg': AlertTriangle,
  'filter.svg': Filter,
  'nightvision.svg': Eye,
  'led.svg': Lightbulb,
  'dualstick.svg': Gauge,
  'medkit.svg': Settings,
  'ir.svg': Zap,
  'floats.svg': Waves,
  'offshore.svg': MapPin,
  'fly.svg': Crosshair,
  'bucket.svg': Droplets,
  'sling.svg': Truck,
  'bird.svg': Mountain,
  'hums.svg': Settings,
  'drop.svg': Droplets,
  'blade.svg': Star,
  
  // Enhanced database icon_ref mappings
  'autonomous': Plane,
  'autopilot': Plane,
  'avionics': Cpu,
  'cloud-rain': CloudRain,
  'CloudRain': CloudRain,
  'combat': Shield,
  'compass': Compass,
  'cpu': Cpu,
  'crosshair': Crosshair,
  'display': Monitor,
  'eye': Eye,
  'gauge': Gauge,
  'gps': MapPin,
  'hard-drive': HardDrive,
  'map-pin': MapPin,
  'mission': Star,
  'monitor': Monitor,
  'Moon': Moon,
  'mountain': Mountain,
  'navigation': Navigation,
  'Navigation': Navigation,
  'phone': Phone,
  'Phone': Phone,
  'plane': Plane,
  'radar': Radar,
  'radio': Radio,
  'safety': Shield,
  'settings': Settings,
  'Settings': Settings,
  'shield': Shield,
  'terrain': Mountain,
  'traffic': AlertTriangle,
  'vision': Eye,
  'volume-2': Volume2,
  'weather': Cloud,
  'wifi': Wifi,
  'Wifi': Wifi,
  'headphones': Headphones,
  'intercom': Radio,
  'Mic': Mic,
  'satellite': Satellite,
  'eye-off': EyeOff,
  
  // Additional common mappings
  'fuel': Fuel,
  'users': Users,
  'wrench': Wrench,
  'star': Star,
  'waves': Waves,
  'truck': Truck,
  'droplets': Droplets,
  'anchor': Anchor,
  'armchair': Armchair,
  'volume-off': VolumeOff,
  'alert-triangle': AlertTriangle,
  'lightbulb': Lightbulb,
  'zap': Zap
};

// Category Lucide icon mappings - Standardized 20 categories
export const categoryIconMapping: Record<string, LucideIcon> = {
  'Agricultural': Wheat,
  'Avionics & Navigation': Satellite,
  'Communication Systems': Radio,
  'Environmental Systems': Waves,
  'External Equipment': Wrench,
  'Interior & Comfort': Armchair,
  'Law Enforcement': Shield,
  'Lighting & Visibility': Lightbulb,
  'Medical & EMS': Heart,
  'Military & Defense': Shield,
  'Mission Equipment': Target,
  'Offshore Operations': Anchor,
  'Performance & Powerplant': Zap,
  'Safety & Emergency': Shield,
  'Search & Rescue': Crosshair,
  'Special Features': Star,
  'Surveillance & Sensors': Camera,
  'Training Equipment': GraduationCap,
  'Utility & Ground Support': HardHat,
  'Weather Systems': Cloud
};

export const getIcon = (iconRef: string | undefined) => {
  if (!iconRef) return Settings; // Default icon
  return iconMapping[iconRef as keyof typeof iconMapping] || Settings;
};

export const getCategoryColor = (category: string) => {
  const colors = {
    'Agricultural': 'text-success',
    'Avionics & Navigation': 'text-primary',
    'Communication Systems': 'text-primary',
    'Environmental Systems': 'text-success',
    'External Equipment': 'text-muted-foreground',
    'Interior & Comfort': 'text-secondary',
    'Law Enforcement': 'text-destructive',
    'Lighting & Visibility': 'text-secondary-glow',
    'Medical & EMS': 'text-destructive',
    'Military & Defense': 'text-destructive',
    'Mission Equipment': 'text-primary-glow',
    'Offshore Operations': 'text-primary',
    'Performance & Powerplant': 'text-primary-glow',
    'Safety & Emergency': 'text-destructive',
    'Search & Rescue': 'text-destructive',
    'Special Features': 'text-secondary',
    'Surveillance & Sensors': 'text-primary',
    'Training Equipment': 'text-success',
    'Utility & Ground Support': 'text-muted-foreground',
    'Weather Systems': 'text-primary'
  };
  return colors[category as keyof typeof colors] || 'text-muted-foreground';
};

export const getCategoryIcon = (category: string): LucideIcon => {
  return categoryIconMapping[category as keyof typeof categoryIconMapping] || Settings;
};